import * as React from "react";
import {AbstractInputElement, FormElement} from "./FormInput";

export class CronSchedule extends AbstractInputElement<string, FormElement<string, HTMLElement>, {}> {

    initialized: boolean;

    initCron(el) {
        if (this.initialized) {
            return;
        }
        this.initialized = true;
        ($(el) as any).jqCron({
            enabled_minute: false,
            multiple_dom: true,
            multiple_month: true,
            multiple_dow: true,
            multiple_time_hours: true,
            multiple_time_minutes: false,
            default_period: 'week',
            default_value: '0 0 * * * *',
            no_reset_button: false,
            numeric_zero_pad: true,
            lang: 'en',
            bind_to: $(el),
            bind_method: {
                set: (el, value) => {
                    this.onChange(value);
                },
                get: (element) => {
                    return this.getModelValue();
                }
            }
        });
    }

    codeChange(e) {
        super.onChange(e);
    }

    render() {
        return <div className="form-control" ref={(el) => {
            this.initCron(el)
        }}></div>;
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/form/CronSchedule.tsx